import React from 'react';
import { CustomLabel6, Table } from '@4beefopag/4bee-fopag-core/dist/atoms';
import PropTypes from 'prop-types';
import { totalGeral } from '../../../services/apontamentoProducao';
import { Total } from '../../atoms/Apontamento';
import { parametrizacaoProps } from '../../atoms/Props';
import { Cell, Header } from '../../atoms/Table';
import ColaboradorAdiantamento from '../../molecules/ColaboradorAdiantamento';
import LegendaSituacaoColaborador from '../../molecules/LegendaSituacaoColaborador';
import AdiantamentoHeader from './AdiantamentoHeader';
import { Wrapper } from './tabelaAdiantamento.styled';

function TabelaAdiantamento({
  onChangeItemValues,
  payrollId,
  isEditable,
  totals,
  parametrizacao,
  items,
  createdByActorKind,
}) {
  return (
    <Wrapper>
      <Table
        widthInput="112px"
        background="#f6f7f9"
        borderBottomTh="1px solid #e8e8e8"
        borderBottomTd="1px solid #e8e8e8"
        style={{ width: '100%' }}
      >
        <thead>
          <tr>
            <Header
              fixed
              width="100px"
              left="0px"
            >
              <CustomLabel6>CPF</CustomLabel6>
            </Header>
            <Header
              fixed
              width="210px"
              left="100px"
            >
              <CustomLabel6>Nome</CustomLabel6>
            </Header>
            <th width="128px">
              <CustomLabel6>Variável</CustomLabel6>
            </th>
            <th width="128px">
              <CustomLabel6>Reembolso</CustomLabel6>
            </th>
            <AdiantamentoHeader parametrizacao={parametrizacao} />
            <th width="128px">
              <CustomLabel6>Total</CustomLabel6>
            </th>
          </tr>
        </thead>
        <tbody>
          {items.map((item) => (
            <ColaboradorAdiantamento
              item={item}
              payrollId={payrollId}
              isEditable={isEditable}
              key={item.id}
              onChangeItemValues={onChangeItemValues}
              parametrizacao={parametrizacao}
              createdByActorKind={createdByActorKind}
            />
          ))}
          <tr>
            <Cell
              colSpan="2"
              fixed
              width="210px"
              left="0px"
            />
            <Total>{totals.variavel}</Total>
            <Total>{totals.reembolso}</Total>
            <Total>{totals.adiantamento}</Total>
            <Total>{totalGeral(totals)}</Total>
          </tr>
          <tr>
            <Cell
              colSpan="3"
              fixed
              width="210px"
              left="0px"
            >
              <LegendaSituacaoColaborador />
            </Cell>
            <td />
            <td />
            <td />
          </tr>
        </tbody>
      </Table>
    </Wrapper>
  );
}

TabelaAdiantamento.propTypes = {
  totals: PropTypes.shape().isRequired,
  onChangeItemValues: PropTypes.func.isRequired,
  parametrizacao: parametrizacaoProps,
  items: PropTypes.arrayOf(),
  payrollId: PropTypes.number.isRequired,
  isEditable: PropTypes.bool.isRequired,
  createdByActorKind: PropTypes.string,
};

TabelaAdiantamento.defaultProps = {
  parametrizacao: {},
  items: [],
  createdByActorKind: undefined,
};

export default TabelaAdiantamento;
